module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "erco-text-input"
  }, [_c('label', {
    staticClass: "label_",
    attrs: {
      "droppable": ("" + _vm.droppable)
    },
    on: {
      "!click": function($event) {
        _vm.handleLabelClick($event)
      }
    }
  }, [_c('span', {
    staticClass: "_text text-muted"
  }, [_vm._v(_vm._s(_vm.label || ' ') + " "), (_vm.showMandatory) ? _c('sup', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), (_vm.tooltip && _vm.tooltip.text) ? _c('erco-tooltip', {
    attrs: {
      "variant": _vm.tooltip.variant,
      "title": _vm.tooltip.title,
      "text": _vm.tooltip.text
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "_input-col col-12"
  }, [_c('b-input-group', [_c('b-form-input', {
    ref: "input",
    class: ['_input', {
      '_focus-outline': _vm.forceFocusOutline,
      '_error': _vm.error
    }],
    style: (_vm.inputStyle),
    attrs: {
      "textarea": _vm.isLongOrComplexText,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled
    },
    on: {
      "focus": _vm.handleFocus,
      "blur": _vm.handleBlur,
      "change": _vm.handleChange,
      "input": _vm.handleInput
    },
    model: {
      value: (_vm.textvalue),
      callback: function($$v) {
        _vm.textvalue = $$v
      },
      expression: "textvalue"
    }
  }), _vm._v(" "), (this.isResetable) ? _c('b-input-group-button', [_c('b-button', {
    staticClass: "_reset",
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": function($event) {
        _vm.handleReset($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t×\n\t\t\t\t\t\t")])], 1) : _vm._e()], 1)], 1)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-171b2b62"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/molecules/ErcoTextInput.vue
// module id = 598
// module chunks = 0